import * as __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__ from "react/jsx-runtime";
import * as __WEBPACK_EXTERNAL_MODULE_class_variance_authority_159ad65c__ from "class-variance-authority";
import * as __WEBPACK_EXTERNAL_MODULE__Heading_module_js_c7117a66__ from "./Heading.module.js";
const headingClass = (0, __WEBPACK_EXTERNAL_MODULE_class_variance_authority_159ad65c__.cva)(__WEBPACK_EXTERNAL_MODULE__Heading_module_js_c7117a66__["default"].heading, {
    variants: {
        tag: {
            h1: __WEBPACK_EXTERNAL_MODULE__Heading_module_js_c7117a66__["default"].headingH1,
            h2: __WEBPACK_EXTERNAL_MODULE__Heading_module_js_c7117a66__["default"].headingH2,
            h3: __WEBPACK_EXTERNAL_MODULE__Heading_module_js_c7117a66__["default"].headingH3,
            h4: __WEBPACK_EXTERNAL_MODULE__Heading_module_js_c7117a66__["default"].headingH4,
            h5: __WEBPACK_EXTERNAL_MODULE__Heading_module_js_c7117a66__["default"].headingH5,
            h6: __WEBPACK_EXTERNAL_MODULE__Heading_module_js_c7117a66__["default"].headingH6
        },
        textAlignment: {
            left: __WEBPACK_EXTERNAL_MODULE__Heading_module_js_c7117a66__["default"].textAlignLeft,
            start: __WEBPACK_EXTERNAL_MODULE__Heading_module_js_c7117a66__["default"].textAlignLeft,
            center: __WEBPACK_EXTERNAL_MODULE__Heading_module_js_c7117a66__["default"].textAlignCenter,
            right: __WEBPACK_EXTERNAL_MODULE__Heading_module_js_c7117a66__["default"].textAlignRight,
            end: __WEBPACK_EXTERNAL_MODULE__Heading_module_js_c7117a66__["default"].textAlignRight,
            justify: __WEBPACK_EXTERNAL_MODULE__Heading_module_js_c7117a66__["default"].textAlignJustify,
            '': ''
        }
    }
});
function Heading({ tag, textAlignment = 'left', styleAs, children, className, ...other }) {
    const Comp = tag;
    const variant = styleAs ?? tag;
    return /*#__PURE__*/ (0, __WEBPACK_EXTERNAL_MODULE_react_jsx_runtime_225474f2__.jsx)(Comp, {
        className: headingClass({
            tag: variant,
            textAlignment,
            className
        }),
        ...other,
        children: children
    });
}
export { Heading as default };

//# sourceMappingURL=Heading.js.map